import { createAsyncAction, createAction } from 'typesafe-actions';
import { createPromiseAction } from 'redux-saga-promise-actions';

export const getPinpadLogin = createAsyncAction('GET_PINPAD_REQUEST', 'GET_PINPAD_SUCCEEDED', 'GET_PINPAD_FAILURE')<
  string,
  any,
  undefined
>();
